<template>
  <div>
    <v-row v-for="(field, index) in inputFieldList" :key="index">
      <v-col cols="12" sm="11">
        <v-text-field
          class="option-field"
          v-model.trim="field.text"
          :label="`${label} ${index + 1} *`"
          @input="addInputField"
          :rules="[rules.required, checkUniqueValue(field.text, field.id)]"
          dense
          required
          :disabled="disabled"
          filled
          :id="`question-option-${index}-${questionId}`"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="1">
        <v-tooltip
          bottom
          v-if="field.showRemoveButton && index > 1 && disabled != true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              v-if="field.showRemoveButton && index > 1 && disabled != true"
              icon
              @click.stop.prevent="removeInputField(field)"
            >
              <v-icon size="20" color="primaryDark">mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("btnDelete") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="disabled != true">
      <v-col cols="12" sm="12">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              @click="addOption"
              color="primary"
              ><v-icon>mdi-plus</v-icon>{{ $t("poll.btnAddOptions") }}</v-btn
            >
          </template>
          <span>{{ $t("poll.btnAddOptions") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import { createUUID } from "../../utils/util";
import { colorPalettes, colorCodes } from "../../utils/constant";

export default {
  name: "OptionForm",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Option",
    },
    questionId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regExp: /[a-zA-Z0-9]/,
      rules: {
        required: (v) => !!(v ? v.trim() : "") || this.$t("msgOptionRequired"),
      },
      colors: ['#B6A6E9', '#876FD4', "#5E40BE", "#3D2785", "#21134D", "#004D99", "#0066CC", "#4394E5", "#63993D", "#3D7317"]
    };
  },
  computed: {
    inputFieldList: {
      get() {      
        return this.getInputFieldList(this.value);
      },
      set(value) {
        const values = Array.isArray(value)
          ? value.map((field) => {
              return {
                text: field.text,
                value: field.value,
                fill: field.fill,
                id: field.id,
              };
            })
          : [];
        this.$emit("input", values);
      },
    },
  },
  mounted() {
  },
  methods: {
    getInputFieldList,
    getUniqueId,
    addInputField,
    removeInputField,
    addOption,
    createUUID,
    getFillColor,
    checkUniqueValue(value, fieldId) {
      const text = value ? String(value).toLowerCase().trim() : ""
      if(text !== ""){
        const option = this.inputFieldList.find(item => item.text.toLowerCase().trim() === text && item.id !== fieldId);
        return option && option.id ? this.$t("poll.ruleMsgOptionUnique") : true
      }else{
        return true
      }
      
    },
  },
};

function addOption() {
  this.inputFieldList.push({
    value: createUUID(),
    text: "",
    showRemoveButton: false,
    fill: "",
    id: this.getUniqueId(),
  });
  this.addInputField();
}

function getInputFieldList(values) {
  const list = [];
  if (values && Array.isArray(values)) {
    values.forEach((value, inc) => {
      list.push({
        text: value.text,
        value: createUUID(),
        showRemoveButton: true,
        fill: this.getFillColor(inc),
        id: this.getUniqueId(),
      });
    });
  }
  return list;
}

function addInputField() {
  const values = this.inputFieldList.map((field) => {
    return {
      text: field.text,
      value: field.value,
      fill: field.fill,
      id: field.id,
      showRemoveButton: true,
    };
  });
  this.$emit("input", values);
}

function removeInputField(field) {
  this.inputFieldList = _.remove(this.inputFieldList, (n) => n.id !== field.id);
}

function getFillColor(inc) {
  if(colorCodes[inc]){
    return colorCodes[inc]
  }
  let code;
  do {
    code =
      "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0");
  } while (this.value.some((i) => i.fill === code));
  return code;

  // const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  // return "#" + randomColor;
}

function getUniqueId() {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}
</script>

<style scoped>
.option-field {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.option-field > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.option-field /deep/ .v-input__slot {
  min-height: 48px !important;
}
.v-text-field--filled {
  border-radius: 0px !important;
}
</style>